import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from 'angularfire2/firestore';
import { MatrixDialogComponent } from '../matrix-dialog/matrix-dialog.component';
import { AngularFireDatabase } from 'angularfire2/database';
import { Component, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import * as horario from './horario.json';

interface Matriz {
  nombre: string;
  miembros: string[];
}

@Component({
  selector: 'app-list',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.css']
})
export class ListComponent {

  matrices: any;

  constructor(public db: AngularFireDatabase, public dialog: MatDialog, public afs: AngularFirestore) {
    this.matrices = afs.collection('matrices').snapshotChanges().map(actions => {
      return actions.map(a => {
        const data = a.payload.doc.data();
        const id = a.payload.doc.id;
        return { id, ...data };
      });
    });
  }

  newMatrix() {
    const dialog = this.dialog.open(MatrixDialogComponent, {
      width: '60%',
    });
    dialog.afterClosed().subscribe(result => {
      const matrices = this.afs.collection<Matriz>('matrices');
      const id = this.afs.createId();
      const temporalMatriz: Matriz = {nombre: result.nombre, miembros: []};
      matrices.doc(id).set(Object.assign({}, temporalMatriz));
      const matriz = matrices.doc(id);
      Object.keys(horario).forEach(contentKey => {
        matriz.collection('horario').doc(contentKey).set(horario[contentKey]);
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/list/list.component.ts